import React from 'react';
import { useDragLayer } from 'react-dnd';
import ItemTypes from './ItemTypes';
import { StyledDragLayer_Box } from './Box';

import { StyledDragLayer } from './WallVisualizerGalleryStyles';
import { percentageToPixelCalc } from '../../Utils/VisualizerUtils';

var CustomDragLayer = function CustomDragLayer() {
  var _useDragLayer = useDragLayer(function (monitor) {
    return {
      item: monitor.getItem(),
      initialOffset: monitor.getInitialSourceClientOffset(),
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging()
    };
  }),
      item = _useDragLayer.item,
      initialOffset = _useDragLayer.initialOffset,
      currentOffset = _useDragLayer.currentOffset,
      isDragging = _useDragLayer.isDragging;

  if (!item || !isDragging) {
    return null;
  }

  var transform = currentOffset ? 'translate(' + currentOffset.x + 'px, ' + currentOffset.y + 'px)' : 'translate(0,0)';

  return React.createElement(
    StyledDragLayer,
    {
      initialOffset: initialOffset,
      currentOffset: currentOffset,
      style: { transform: transform },
      width: percentageToPixelCalc(item.width)
    },
    item.type === ItemTypes.BOX && React.createElement(StyledDragLayer_Box, { img: item.img, alt: item.alt })
  );
};
export default CustomDragLayer;